<template lang="pug">
  .notice(v-bind:class="{ 'top': top, 'small': small }")
    .notice-padding
      slot
</template>

<script>
export default {
  props: ['top', 'small']
}
</script>

<style lang="scss" scoped>
  .notice {
    width: 100%;
    margin: 12px 0px;
    a {
      float:right;
      color: #eee;
    }
    &.success {
      background-color: $secondary;
    }
    &.small {
      margin: 5px 0 0 0;
      .notice-padding {
        padding: 16px;
        line-height:18px;
        font-size:14px;
      }
    }
    &.top {
      margin: 0 0 15px 0;
    }
    background: $gradient-8;
    .notice-padding {
      color:#eee;
      padding: 22px;
    }
  }
</style>